<button
  data-testid="logoutFromCurrentDeviceBtn"
  sdButton
  radius="l"
  type="outlined-gray"
  [fullWidth]="true"
  size="m"
  (click)="logout()"
>
  Выйти
</button>
